import { formatPrice } from 'utils/price';

const BookingTotal = ({ total = 0.0 }: { total?: number }) => {
  return (
    <div className="booking-total">
      <div className="booking-total__label">Booking Total</div>
      <div className="booking-total__price" data-cy="bookingTotal">
        {formatPrice(total)}
      </div>
    </div>
  );
};

export default BookingTotal;
